import styled from 'styled-components';

export const Container = styled.footer`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 0;

  color: #999;

  .sbfv-logo {
    margin: 0 7px 0 px;
  }
`;
